import assert from 'assert';
function value_is_non_array_object(maybe) {
    return ('object' === typeof maybe
        && !(maybe instanceof Array)
        && null !== maybe);
}
export function array_has_size(maybe, size, message) {
    assert.strictEqual(maybe.length, size, message);
}
export function is_instanceof(maybe, of, message) {
    assert.strictEqual(maybe instanceof of, true, message);
}
export function not_undefined(maybe, message) {
    assert.strictEqual(undefined !== maybe, true, message);
}
export function object_has_property(maybe, property, message) {
    assert.strictEqual(typeof maybe, 'object', message);
    assert.strictEqual(maybe instanceof Array, false, message);
    assert.strictEqual(property in maybe, true, message);
}
function resolve_partial(actual, expecting, message) {
    const partial_match = {};
    for (const entry of Object.entries(expecting)) {
        const [property, expecting_value] = entry;
        object_has_property(actual, property, message);
        const actual_value = actual[property];
        if (value_is_non_array_object(actual_value)
            && value_is_non_array_object(expecting_value)) {
            partial_match[property] = resolve_partial(actual_value, expecting_value);
        }
        else {
            partial_match[property] = actual_value;
        }
    }
    return partial_match;
}
export async function rejects_partial_match(maybe, partial_error, message) {
    let failure = undefined;
    await assert.rejects(maybe);
    await maybe.catch((err) => { failure = err; });
    assert.strictEqual(value_is_non_array_object(failure), true, message);
    const partial_match = resolve_partial(failure, partial_error, message);
    assert.deepStrictEqual(partial_match, partial_error, message);
}
//# sourceMappingURL=CustomAssert.js.map